import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CustomerSearchItem } from '@shared/customer/models/customer-search-item.model';
import { CustomerSearchStateService } from '@shared/customer/services/customer-search-state.service';
import { TableFilterAbstractComponent } from '@shared/models/abstact-table-filter.model';

@Component({
  selector: 'app-orders-customer-filter',
  templateUrl: './orders-customer-filter.component.html',
  styleUrls: ['./orders-customer-filter.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CustomerSearchStateService],
})
export class OrdersCustomerFilterComponent extends TableFilterAbstractComponent implements OnInit {
  private readonly customerSearch = inject(CustomerSearchStateService);

  readonly customerData = this.customerSearch.customerDataSignal;
  readonly isLoading = this.customerSearch.isLoadingSignal;
  public selectedCustomerId = 0;

  ngOnInit(): void {
    this.getResetFilterValue();
  }

  public onSearchTrigger(event: { searchTerm: string }) {
    this.customerSearch.triggerSearch(event.searchTerm);
  }

  public onCustomerSelected(customer: CustomerSearchItem) {
    this.selectedCustomerId = customer.id;
    this.filterResultChange.emit({
      field: this.filter?.field,
      type: this.filter?.type,
      result: customer.id.toString(),
      condition: this.filter?.operator,
    });
  }

  public onClearTrigger(): void {
    this.selectedCustomerId = 0;
    this.customerSearch.clearData();
  }

  clearFilter() {
    this.selectedCustomerId = 0;
    this.customerSearch.clearData();
  }
}
